export default __webpack_public_path__ + "3jm6Zi.png";